export const DataControllerProcessorSection = () => (
  <section>
    <h2>10. Data Controller/Processor</h2>

    <p>
      Certain data protection laws and regulations, such as the GDPR or the
      CCPA, typically distinguish between two main roles for parties processing
      Personal Data: the "data controller" (or under the CCPA, "business"), who
      determines the purposes and means of processing; and the "data processor"
      (or under the CCPA, "service provider"), who processes the data on behalf
      of the data controller (or business). Below we explain how these roles
      apply to our Services, to the extent that such laws and regulations apply.
    </p>

    <p>
      Volca is the "data controller" of Volca Website, CRM & Prospect Data. With
      respect to such data, we assume the responsibilities of data controller
      (solely to the extent applicable under law), as set forth in this Privacy
      Policy. In such instances, our Service Providers processing such data will
      assume the role of "data processor".
    </p>

    <p>
      Volca is the "data processor" of Customer Data, which we process on behalf
      of our customer (who is the "data controller" of such data; and our
      Service Providers who process such Customer Data on our behalf are the
      "sub-processors" of such data.
    </p>

    <p>
      Volca is both a "data controller" and "data processor" of Volca User Data.
      Such data is processed by Volca for its own purposes (as described in
      Section ‎2 above), as an independent 'controller'; whilst those certain
      portions of it which are included in Customer Data will be processed by us
      on our customer's behalf, as a 'processor'.
    </p>

    <p>
      Accordingly, Volca processes Customer Data strictly in accordance with
      such customer's reasonable instructions and as further stipulated in our
      Data Processing Addendum and other commercial agreements with such
      customer. The customer, as controller of such data, will be responsible
      for meeting any legal requirements applicable to data controllers (such as
      establishing a legal basis for processing and responding to Data Subject
      Rights requests concerning the data they control).
    </p>

    <p>
      For the avoidance of doubt, each customer is solely responsible for
      providing adequate notice to their account users and customers whose data
      may be contained in Customer Data – including sufficient reference to the
      processing of their Personal Data via the Services, and any other
      information necessary to comply with all applicable privacy and data
      protection laws; and to obtain all approvals and consents from such
      individuals as required under such laws.
    </p>
  </section>
);
